import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getLocaleFullName } from '../utils/commonUtils';

const useAuth = () => {
  const authReducer = useSelector(state => state.authReducer);

  return useMemo(() => {
    authReducer.fullName = getLocaleFullName(
      authReducer?.user?.firstname,
      authReducer?.user?.lastname
    );

    return authReducer;
  }, [authReducer]);
}

export default useAuth;